import React from 'react'
import { Users, Plus, Share2 } from 'lucide-react'

export const ReferralsList = ({ referrals, onInvite }) => {
  if (!referrals || referrals.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Users className="w-10 h-10 text-gray-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 mb-2">No Referrals Yet</h3>
        <p className="text-gray-600 mb-6">Start inviting friends to earn rewards</p>
        <button 
          onClick={onInvite}
          className="inline-flex items-center gap-2 px-6 py-3 bg-teal-500 text-white rounded-xl hover:bg-teal-600 transition-all duration-200 font-medium"
        >
          <Share2 className="w-4 h-4" />
          Share Your Code
        </button>
      </div>
    )
  }

  return (
    <div className="space-y-4">
      {referrals.map((referral) => (
        <div key={referral.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-all duration-200">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold">
              {referral.referred_user_name?.split(' ').map(n => n[0]).join('') || 'U'}
            </div>
            <div>
              <p className="font-semibold text-gray-900">{referral.referred_user_name}</p>
              <p className="text-sm text-gray-600">{referral.property_title || 'No property'}</p>
              <p className="text-xs text-gray-500">
                {new Date(referral.referred_at).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric'
                })}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className={`px-3 py-1 rounded-full text-xs font-medium ${
              referral.status === 'completed' 
                ? 'bg-green-100 text-green-800' 
                : 'bg-amber-100 text-amber-800'
            }`}>
              {referral.status === 'completed' ? '✓ Completed' : '⏳ Pending'}
            </span>
            {referral.status === 'completed' && (
              <span className="text-green-600 font-semibold text-sm">+AED 100</span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}